export default "data:image/webp;base64,UklGRjoAAABXRUJQVlA4TC4AAAAvJ8AEACATsKivg2A+VXwL4BIIJBb7MywYQbaN2WAGOoFDvf8T4OR9cxwJ/PcA"